import type { DateWindow, ScopeCount } from './EmptyScope';
import { useGetCrawlerRequestsTotalQuery } from './CrawlerRequestsTotalAPI';

export function useCrawlerRequestsTotal({ dateFrom, dateTo }: DateWindow, options: { skip: boolean }): ScopeCount {
  const result = useGetCrawlerRequestsTotalQuery({ dateFrom, dateTo }, options);
  return { value: result.currentData, isFetching: result.isFetching };
}
